var React = require('react');

function ExpandMoreIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 7.99805L12 15.998L4 7.99805","stroke":"#3D5265","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ExpandMoreIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ExpandMoreIcon;

ExpandMoreIcon.default = ExpandMoreIcon;
